// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarPanel__container-caf702 {
  display: flex;
  width: var(--sidebar-width);
  border-right: 1px solid var(--base-20);
  background-color: var(--base-0);
  position: relative;
  z-index: 1;
  user-select: none;
}

.SidebarPanel__colapsed-f020a1 {
  width: var(--sidebar-navigation-width);
  border-right: 0 none;
}

.SidebarPanel__content-b46190 {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1;
  width: var(--group-list-width);
}

.SidebarPanel__list-d0752a {
  display: flex;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
}

.SidebarPanel__footer-f33004 {
  display: flex;
  flex-direction: column-reverse;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,sCAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,sCAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  width: var(--sidebar-width);\n  border-right: 1px solid var(--base-20);\n  background-color: var(--base-0);\n  position: relative;\n  z-index: 1;\n  user-select: none;\n}\n\n.colapsed {\n  width: var(--sidebar-navigation-width);\n  border-right: 0 none;\n}\n\n.content {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1;\n  width: var(--group-list-width);\n}\n\n.list {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n}\n\n.footer {\n  display: flex;\n  flex-direction: column-reverse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SidebarPanel__container-caf702`,
	"colapsed": `SidebarPanel__colapsed-f020a1`,
	"content": `SidebarPanel__content-b46190`,
	"list": `SidebarPanel__list-d0752a`,
	"footer": `SidebarPanel__footer-f33004`
};
module.exports = ___CSS_LOADER_EXPORT___;
